var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.chosenAvatarImage
    ? _c("img", {
        staticClass: "avatar",
        attrs: { src: _vm.chosenAvatarImage, alt: _vm.headerTitle },
      })
    : _c("div", { staticClass: "avatar" }, [
        _c("div", { staticClass: "avatar-initial-outer" }, [
          _c("div", { staticClass: "avatar-initial-inner" }, [
            _vm._v("\n      " + _vm._s(_vm.nameInitials) + "\n    "),
          ]),
        ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }